import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

const CenterIntroTextArea = forwardRef((props, ref) => {
	const { className, placeholder, type, defaultValue, setVal } = props;
	const [value, setValue] = useState(defaultValue);
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			return value;
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			setChangedPlaceholderColor(true);
			inputRef.current.style.borderColor = '#FF3131';
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = '#E8E8E8';
		}
	}));

	useEffect(() => {
		inputRef.current.style.height = `${(inputRef.current.scrollHeight + 9)}px`;
	}, [])

	function handleChange(e) {
		if (e.target.value.length > 250) {
			alert('최대 250자까지 입력할 수 있습니다');
			return;
		}
		
		setValue(e.target.value);
    setVal(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
	}

  function onPress(e) {
    if (e.key === 'Enter') {
      inputRef.current.style.height = `${(inputRef.current.scrollHeight + 9)}px`;
    }
  }

 
	return <Input
		ref={inputRef}
		clickCount={clickCount}
		type={type}
		placeholder={defaultPlaceholder}
		value={value}
		changedColor={changedPlaceholderColor}
		className={`${className} ${changed ? "changed" : ""}`}
		onChange={handleChange}
		onFocus={handleFocus}
		onBlur={handleBlur} 
    onKeyPress={onPress}/>
});

export default CenterIntroTextArea;

const Input = styled.textarea`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 6px 8px 6px 8px;

  width: 1117px;
  height: 71px;
  resize: none;
  overflow-y: hidden;
  // resize: vertical;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;
  border: 1px solid #DFDFDF;
  border-radius: 8px;

  color: #595959;

	outline: none;

	::placeholder {
		color: ${props => props.changedColor ? `#FF3131` : `#CBCBCB`};
	}
	
  // transition: all 0.3s ease-in-out;
`;